export const SIZE_OPTION_NAMES = ["Width", "Height", "Depth"];

export default SIZE_OPTION_NAMES;
